import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DragulaService } from 'ng2-dragula';
import { ToastrService } from 'ngx-toastr';
import constant from 'src/app/app.constant';
import { CommonHttpService } from 'src/app/utils/common-http.service';
declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'app-delivery-partner-map',
  templateUrl: './delivery-partner-map.component.html',
  styleUrls: ['./delivery-partner-map.component.scss']
})
export class DeliveryPartnerMapComponent implements OnInit {
  public constant = constant;
  public deliveryPartnerList: any = [];
  deliveryPartnerShow: boolean = true;
  UserDeliveryPartnerMap: any = [];
  dpFormGroup: FormGroup;
  submitted = false;
  dp_rearrange_with_eta: any;
  dp_push_mechanisum: any;

  @Output() dpRearrangEvent = new EventEmitter();

  constructor(private toaster: ToastrService, private dragulaService: DragulaService, public activeModal: NgbActiveModal, private http: CommonHttpService, private _formBuilder: FormBuilder,) {
    this.dragulaService.createGroup("DPM", {
      // removeOnSpill: true
    });
  }
  @Input() userData: any;

  ngOnInit() {
    this.dpFormGroup = this._formBuilder.group({
      delivery_partner_user_id: [null, Validators.required],
      waiting_time_in_min: [null, Validators.required],
    });
    if (this.userData) {
      this.dp_rearrange_with_eta = this.userData?.dp_rearrange_with_eta;
      this.dp_push_mechanisum = this.userData?.dp_push_mechanisum;
      this.getDeliveryPartnerDetails();
    }
  }
  getDeliveryPartnerDetails() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderGetMap + '/' + this.userData?.userId).subscribe((response: any) => {
      if (response.status) {
        var deliveryPartnerList = response?.data?.DeliveryPartner
        this.UserDeliveryPartnerMap = response?.data?.UserDeliveryPartnerMap
        if (_.isArray(this.UserDeliveryPartnerMap) && !_.isEmpty(this.UserDeliveryPartnerMap)) {
          this.deliveryPartnerList = [];
          var delivery_partner = [] = this.UserDeliveryPartnerMap?.map((element: any) => {
            if (element?.delivery_partner_user_id) {
              let newDate = moment().format('x');
              // element.DeliveryPartner.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + element?.DeliveryPartner.icon_url + '&=' + newDate;
              return element.delivery_partner_user_id;
            }
          })
          deliveryPartnerList?.filter((item: any) => {
            if (!delivery_partner.includes(item.user_id)) {
              this.deliveryPartnerList.push(item);
            };
          });
        } else {
          this.deliveryPartnerList = [];
          this.deliveryPartnerList = deliveryPartnerList;
        }
      }
    })
  }
  thirdPartyMethod() {
    var reqJson: any = {
      dp_push_mechanisum: this.dp_push_mechanisum,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      vendor_agency_user_id: this.userData.vendor_agency_user_id,
      under_role_id: this.userData.under_role_id,
    }
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_push_mechanisum: this.dp_push_mechanisum });

    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated')
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  deliveryPartnerAdd() {
    this.deliveryPartnerShow = false;
    this.submitted = false;
    this.dpFormGroup.reset();
  }
  backBtn() {
    this.deliveryPartnerShow = true;
  }
  ngOnDestroy() {
    this.dragulaService.destroy('DPM');
  }
  closeModal() {
    this.activeModal.dismiss();
  }

  editFunction(event: any, i: any) {
    if (event?.target?.value) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = event?.target?.value;
    }
    // this.updateData();
  }

  interChangeList(item: any) {
    var changeItem = [] = item;
    this.UserDeliveryPartnerMap = [...changeItem];
  }

  addDeliveryPartner() {
    this.submitted = true;
    if (this.dpFormGroup.valid) {
      var reqData = [{
        delivery_partner_user_id: this.dpFormGroup.value.delivery_partner_user_id,
        user_id: this.userData.userId,
        waiting_time_in_min: this.dpFormGroup.value.waiting_time_in_min,
        status: "Active",
        sort_order: null
      }]
      if (this.UserDeliveryPartnerMap) {
        reqData[0].sort_order = this.UserDeliveryPartnerMap.length + 1
      } else {
        reqData[0].sort_order = 1;
      }
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, reqData).subscribe((response: any) => {
        if (response.status) {
          this.submitted = false;
          this.deliveryPartnerShow = true;
          this.getDeliveryPartnerDetails();
        }
      })
    }
  }
  checkValue(event: any) {
    var reqJson: any = {
      dp_rearrange_with_eta: this.dp_rearrange_with_eta,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      vendor_agency_user_id: this.userData.vendor_agency_user_id,
      under_role_id: this.userData.under_role_id,
    }
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_rearrange_with_eta: this.dp_rearrange_with_eta });
    // if (event.target.checked) reqJson.dp_rearrange_with_eta = this.dp_rearrange_with_eta;
    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated')
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  allowCod(event: any, i: any) {
    this.UserDeliveryPartnerMap[i].allow_cod = event?.target?.checked;
    // this.updateData();
  }
  activeAndInactive(event: any, i: any) {
    this.UserDeliveryPartnerMap[i].status = (event?.target?.checked) ? 'Active' : 'InActive';
    var removeItem = {}
    if (!event.target.checked) {
      this.UserDeliveryPartnerMap.forEach((element: any, index: any) => {
        if (index == i) {
          removeItem = element;
          this.UserDeliveryPartnerMap.splice(index, 1)
        };
      });
      this.UserDeliveryPartnerMap.push(removeItem);
    }
    // this.updateData();
  }

  updateData() {
    var requiredWaitingTime: boolean = true;
    this.UserDeliveryPartnerMap.map((item: any, i: any) => {
      item.sort_order = i + 1
      if (!Number(item?.waiting_time_in_min) && item.status == 'Active') {
        this.toaster.error(`Please fill waiting time for ${item?.DeliveryPartner?.full_name}`);
        return requiredWaitingTime = false;
      } else if (!item?.waiting_time_in_min) {
        item.waiting_time_in_min = 1;
      }
      return item;
    })
    if (requiredWaitingTime) {
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, this.UserDeliveryPartnerMap).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success(response.message)
        }
      })
    }
  }

  deleteDeliveryPartner(event: any, index: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success w-25 mr-05',
        cancelButton: 'btn btn-danger w-25 mr-05'
      },
      buttonsStyling: false,
    })
    swalWithBootstrapButtons.fire({
      title: 'Would you like to remove the delivery partner?',
      text: "",
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.http.deleteDataParams(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DeleteDp + '?delivery_partner_user_id=' + event.delivery_partner_user_id + '&vendor_user_id=' + this.userData.userId).subscribe((response: any) => {
          if (response.status) {
            this.toaster.success(response.message);
            this.getDeliveryPartnerDetails();
          }
        })
      } else if (
        // Read more about handling dismissals
        result.dismiss === Swal.DismissReason.cancel
      ) {

      }
    })

  }
}
